import React, { useEffect, useState } from 'react';
// Material
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
// Hooks
import useNotify from '../../../../hooks/notify';
//Services
import OrderService from '../../../../services/orderService';
// Components
import PrintModal from '../index';
import Modal from '../../../../components/modal/index';
import Spinner from '../../../../components/spinner';

const InvoicePrintModal = ({ voucher, open, onClose }) => {
    const { Notify, variants } = useNotify();
    const [loading, setLoading] = useState(false);
    const [invoice, setInvoice] = useState("");
    const [printerId, setPrinterId] = useState();
    const [isTaxFree, setIsTaxFree] = useState(false);
    
    useEffect(() => {
        if(voucher) {
            OrderService.GetTicket( voucher.id, voucher.type )
                .then(res => setInvoice(res))
                .catch(() => Notify("Error al intentar obtener factura", variants.ERROR));
        }
    }, [voucher, Notify, variants.ERROR]);

    const printInvoice = async () => {
        setLoading(true);
        OrderService.PrintTicket( voucher.id, voucher.type, printerId, isTaxFree)
            .then(() => Notify("Se a impreso correctamente", variants.SUCCESS))
            .catch(() => Notify("Error al intentar imprimir ticket", variants.ERROR))
            .finally(() => setLoading(false));
    }

    return (
        <Modal
            title='Comprobante'
            open={open}
            onClose={onClose}
            contentProps={{ dividers: true }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        color="primary"
                    >
                        Cerrar
                    </Button>
                    <Button
                        onClick={printInvoice}
                        color="primary"
                        variant='outlined'
                        disabled={!printerId || !voucher.isPrintable}
                    >
                        Imprimir
                    </Button>
                </DialogActions>
            }
        >
            {
                loading &&
                <Spinner lockScreen message='Procesando orden' />
            }
            <PrintModal
                ticket={invoice}
                setPrinter={setPrinterId}
                loading={!invoice}
                setIsTaxFree={setIsTaxFree}
                isTaxFree={isTaxFree}
            />
        </Modal>
    );
}

export default InvoicePrintModal;